import styled from 'styled-components';

const DashAppHolder = styled.div`
  font-family: 'Roboto', sans-serif;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  li,
  input,
  textarea,
  span,
  div,
  img,
  svg {
    &::selection {
      background: '#4482FF';
      color: #fff;
    }
  }

  .ant-row:not(.ant-form-item) {
    ${'' /* margin-left: -8px;
    margin-right: -8px; */};
    &:before,
    &:after {
      display: none;
    }
  }

  .ant-row > div {
    padding: 0;
  }

  .isoLeftRightComponent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .isoCenterComponent {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  a {
    color: #00598d;

    &:hover {
      color: #1A73A7;
    }
  }
`;

export default DashAppHolder;


// WEBPACK FOOTER //
// ./src/dashAppStyle.js